import { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { useRouter } from 'next/router';
import Slider from 'react-slick';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
import {
  getHomeSlide,
  getHomeService,
  getHomeProject,
  getHomeImageCompany,
} from '@/redux/actions/homeSlide';
import Link from 'next/link';
import ReactPlayer from 'react-player';
export default function Home(props) {
  const trans = useTrans();
  const slider_feature = useRef();
  const [isShowModal, setIsShowModal] = useState(false);
  const [listSilde, setListSlide] = useState([]);
  const [service, setService] = useState([]);
  const [project, setProject] = useState([]);
  const [company, setCompany] = useState([]);

  const refClickYoutube = useRef();

  useEffect(() => {
    (async () => {
      const listSlideHome = await getHomeSlide();
      const listService = await getHomeService();
      const listProject = await getHomeProject();
      const imgCompany = await getHomeImageCompany();
      setListSlide(listSlideHome?.rows);
      setService(listService?.rows);
      setProject(listProject ? listProject : []);
      setCompany(imgCompany);
    })();
  }, []);

  const setting_office = {
    dots: true,
    infinite: true,
    // autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    appendDots: dots => {
      let arrDost = [];
      for (let i = 0; i < dots?.length; i++) {
        if (dots[i].props.className !== '') {
          if (i === 0) {
            arrDost?.push(dots[i], dots[i + 1], dots[i + 2]);
            break;
          } else {
            arrDost?.push(dots[i - 1], dots[i], dots[i + 1]);
            break;
          }
        }
      }
      return (
        <ul className="slick-dots">{arrDost.length > 0 ? arrDost : dots}</ul>
      );
    },
  };

  const dataSEO = {
    title: `TCOM Global`,
    description: trans.seo.home.description,
  };

  const makeid = length => {
    var text = '';
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  };

  const cooperate = [
    {
      id: 1,
      icon: '/assets/img/slider/method1.svg',
      title: ' Project based',
      text: trans.home.project_based_a,
      next: '/assets/img/slider/next6.svg',
      url: '/offshore',
      img: '/assets/img/slider/img1.svg',
    },
    {
      id: 2,
      icon: '/assets/img/slider/method2.svg',
      title: 'Dedicated team (labor)',
      text: trans.home.project_based_b,
      next: '/assets/img/slider/next6.svg',
      url: '/offshore',
      img: '/assets/img/slider/img2.svg',
    },
  ];

  const mySettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    appendDots: dots => {
      return (
        <div
          style={{
            borderRadius: '10px',
            position: 'absolute',
            top: '95%',
            left: '50%',
            transform: 'translateX(-50%)',
            justifyContent: 'center',
          }}
        >
          <ul
            style={{ margin: '0px', display: 'flex', padding: 0 }}
            className="pagi-slick"
          >
            {dots}
          </ul>
        </div>
      );
    },
    customPaging: dots => {
      return <button className="LiSlick"></button>;
      // use asNarFor to paginator
    },
  };

  const mySettings_mb = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    appendDots: dots => {
      return (
        <div
          style={{
            borderRadius: '10px',
            position: 'absolute',
            top: '95%',
            left: '50%',
            transform: 'translateX(-50%)',
            justifyContent: 'center',
          }}
        >
          <ul
            style={{ margin: '0px', display: 'flex', padding: 0 }}
            className="pagi-slick"
          >
            {dots}
          </ul>
        </div>
      );
    },
    customPaging: dots => {
      return <button className="LiSlick"></button>;
      // use asNarFor to paginator
    },
  };

  const setting_project_feature = {
    dots: true,
    infinite: true,
    // autoplay: true,
    // speed: 500,
    autoplaySpeed: 3000,
    arrows: false,
    centerPadding: '100px',
    slidesToShow: 3,
    slidesToScroll: 1,
    appendDots: dots => {
      return (
        <div
          style={{
            borderRadius: '10px',
            position: 'absolute',
            bottom: '-10%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <ul
            style={{ margin: '0px', display: 'flex', padding: 0 }}
            className="pagi-slick-f"
          >
            {dots}
          </ul>
        </div>
      );
    },
    customPaging: dots => {
      return <button className="LiSlick-f"></button>;
      // use asNarFor to paginator
    },

    responsive: [
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const setting_project_feature_mb = {
    dots: false,
    infinite: true,
    // autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  const tech_language = [
    {
      id: makeid(10),
      title: 'Frontend',
      img: '/assets/img/slider/fe.png',
      details: [
        {
          id: makeid(10),
          img: '/assets/img/slider/react.svg',
          name: 'ReactJS',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/ang.svg',
          name: 'Angular',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/nextjs.svg',
          name: 'NextJS',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/vue.svg',
          name: 'Vue.JS',
        },
      ],
    },
    {
      id: makeid(10),
      title: 'Mobility',
      img: '/assets/img/slider/mobility.png',
      details: [
        {
          id: makeid(10),
          img: '/assets/img/slider/apk.svg',
          name: 'Android',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/ios.svg',
          name: 'iOS',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/native.svg',
          name: 'ReactNative',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/fluter.svg',
          name: 'Fluter',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/swift.svg',
          name: 'Swift',
        },
      ],
    },
    {
      id: makeid(10),
      title: 'AI',
      img: '/assets/img/slider/ai.png',
      details: [
        {
          id: makeid(10),
          img: '/assets/img/slider/ten.svg',
          name: 'Tensorflow',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/pyt.svg',
          name: 'PyTourch',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/python.svg',
          name: 'Python',
        },

        {
          id: makeid(10),
          img: '/assets/img/slider/mcl.svg',
          name: 'Marchine learning',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/dln.svg',
          name: 'Deep learning',
        },
      ],
    },
    {
      id: makeid(10),
      title: 'Blockchain',
      img: '/assets/img/slider/blockchain.png',
      details: [
        {
          id: makeid(10),
          img: '/assets/img/slider/eth.svg',
          name: 'Ethereum',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/sc.svg',
          name: 'Smart Contract',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/dapps.svg',
          name: 'dApps',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/wallet.svg',
          name: 'Wallet',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/bn.svg',
          name: 'Blockchain Network',
        },
      ],
    },
    {
      id: makeid(10),
      title: 'Database',
      img: '/assets/img/slider/database.png',
      details: [
        {
          id: makeid(10),
          img: '/assets/img/slider/sql.svg',
          name: 'MySQL',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/sqls.svg',
          name: 'SQL Server',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/redis.svg',
          name: 'Redis',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/mg.svg',
          name: 'Mongo',
        },

        {
          id: makeid(10),
          img: '/assets/img/slider/graph.svg',
          name: 'GraphQL',
        },
      ],
    },
    {
      id: makeid(10),
      title: 'DevOps',
      img: '/assets/img/slider/lg1.png',
      details: [
        {
          id: makeid(10),
          img: '/assets/img/slider/gitlab.svg',
          name: 'Gitlab',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/jen.svg',
          name: 'Jenkins',
        },

        {
          id: makeid(10),
          img: '/assets/img/slider/docker.svg',
          name: 'Docker',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/Kubernetes.svg',
          name: 'Kubernetes',
        },
        {
          id: makeid(10),
          img: '/assets/img/slider/aws.svg',
          name: 'AWS',
        },
      ],
    },
  ];

  return (
    <>
      <MetaSeo {...dataSEO} />
      <div className="p-home">
        <div className="p-home__slider">
          <div className="p-home__slider__item">
            <Slider {...mySettings}>
              {listSilde &&
                listSilde?.map((data, index) => {
                  return (
                    <div>
                      <div
                        className="p-home__slider__item_a"
                        style={{ backgroundImage: `url(${data.image})` }}
                        key={index}
                      >
                        <div className="p-home__slider__content">
                          <div
                            className="p-home__slider__follow"
                            data-aos="fade-right"
                            data-aos-delay="1200"
                          >
                            <div className="p-home__slider__follow-label">
                              Follow Us
                            </div>
                            <ul>
                              <li className="facebook">
                                <a
                                  href="https://www.facebook.com/TCOM.Corporation"
                                  target="_blank"
                                >
                                  <svg
                                    width={11}
                                    height={20}
                                    viewBox="0 0 11 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.55303 3.29509H10.3647V0.139742C10.0522 0.0967442 8.97722 0 7.72533 0C5.11324 0 3.32389 1.643 3.32389 4.66274V7.44186H0.441406V10.9693H3.32389V19.845H6.85794V10.9701H9.62384L10.0629 7.44269H6.85712V5.01251C6.85794 3.99297 7.13247 3.29509 8.55303 3.29509Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </li>
                              <li className="linkedin">
                                <a
                                  href="https://www.linkedin.com/company/tcom-corporation"
                                  target="_blank"
                                >
                                  <svg
                                    width={17}
                                    height={16}
                                    viewBox="0 0 17 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0.739195 15.2647H3.82885V4.96661H0.739195V15.2647ZM12.776 4.6099C11.2765 4.6099 9.93487 5.15749 8.98311 6.36616V4.93274H5.88212V15.2648H8.98311V9.6775C8.98311 8.49669 10.0649 7.34477 11.4199 7.34477C12.775 7.34477 13.1091 8.49669 13.1091 9.64861V15.2638H16.1988V9.41866C16.1987 5.35855 14.2765 4.6099 12.776 4.6099ZM2.26958 3.93748C3.12347 3.93748 3.8165 3.24445 3.8165 2.39056C3.8165 1.53667 3.12347 0.84375 2.26958 0.84375C1.41569 0.84375 0.722656 1.53678 0.722656 2.39067C0.722656 3.24456 1.41569 3.93748 2.26958 3.93748Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </li>
                              <li className="youtobe">
                                <a
                                  href="https://www.youtube.com/channel/UCmeadb8H2pD_05cFz0qvDVw"
                                  target="_blank"
                                >
                                  <svg
                                    width="23"
                                    height="16"
                                    viewBox="0 0 23 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M22.2323 2.88581C22.107 2.41607 21.8615 1.98769 21.5202 1.64355C21.1789 1.29941 20.7539 1.05158 20.2876 0.924854C18.5713 0.459961 11.6914 0.459961 11.6914 0.459961C11.6914 0.459961 4.8115 0.459961 3.0952 0.922381C2.62873 1.04869 2.20348 1.29639 1.86213 1.64059C1.52079 1.9848 1.27539 2.41339 1.15056 2.88334C0.691406 4.61433 0.691406 8.22467 0.691406 8.22467C0.691406 8.22467 0.691406 11.835 1.15056 13.5635C1.40346 14.518 2.14989 15.2698 3.0952 15.5245C4.8115 15.9894 11.6914 15.9894 11.6914 15.9894C11.6914 15.9894 18.5713 15.9894 20.2876 15.5245C21.2354 15.2698 21.9794 14.518 22.2323 13.5635C22.6914 11.835 22.6914 8.22467 22.6914 8.22467C22.6914 8.22467 22.6914 4.61433 22.2323 2.88581ZM9.50614 11.5383V4.91107L15.2026 8.19994L9.50614 11.5383Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </li>
                            </ul>
                          </div>

                          <div className="itbsbqbsfbas">
                            <div
                              className="sdbb1hd823hfs"
                              dangerouslySetInnerHTML={{
                                __html: data.title,
                              }}
                            ></div>

                            <p className="uqweqweu24qweuqw">
                              {data.description}
                            </p>
                            <Link href={data.link}>
                              <div
                                className="p-home__our-service-item-btn project-btn btn-slider-home"
                                style={{ cursor: 'pointer' }}
                              >
                                <p style={{ margin: '0' }}>
                                  {trans.text_button.read_more_b}
                                </p>
                                <div>
                                  <img src="/assets/img/tgo/next.svg" alt="" />
                                </div>
                              </div>
                            </Link>
                          </div>

                          <div className="p-home__text-mobile">
                            <div
                              className="p-home__text"
                              data-aos="fade-up"
                              data-aos-delay="800"
                            >
                              <p>{trans.home.slider_text}</p>
                            </div>
                            <div
                              className="p-home__icon"
                              data-aos="fade-up"
                              data-aos-delay="800"
                            >
                              <div className="p-home__icon-items">
                                <div className="p-home__icon-item">
                                  <div>
                                    <img
                                      src="/assets/img/slider/ico_chiphi.svg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="text-home">
                                    <p>{trans.home.slider_text_icon_a}</p>
                                  </div>
                                </div>
                                <div className="p-home__icon-item">
                                  <div>
                                    <img
                                      src="/assets/img/slider/ico_chatluong.svg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="text-home">
                                    <p>{trans.home.slider_text_icon_b}</p>
                                  </div>
                                </div>
                                <div className="p-home__icon-item">
                                  <div>
                                    <img
                                      src="/assets/img/slider/ico_trienkhai.svg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="text-home">
                                    <p>{trans.home.slider_text_icon_c}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>

          <div className="p-home__slider__item-mobile">
            <Slider {...mySettings_mb}>
              {listSilde &&
                listSilde?.map((data, index) => {
                  return (
                    <div key={index}>
                      <div
                        className="p-home__slider__item_a_mb"
                        style={{ backgroundImage: `url(${data.image_mobile})` }}
                      >
                        <div className="p-home__slider__content-mb">
                          <p>
                            {/* <div className="text-mb-slide">{data.title}</div> */}
                            <div
                              className="sdbb1hd823hfs"
                              dangerouslySetInnerHTML={{
                                __html: data.title,
                              }}
                            ></div>
                          </p>

                          <p>
                            <div className="sub_text-mb-slide">
                              {data.description}
                            </div>
                          </p>
                          <Link href={data.link}>
                            <a style={{ width: '100%' }}>
                              <div
                                style={{
                                  paddingTop: '20px important',
                                  cursor: 'pointer',
                                }}
                                className="btn-slider-home-mb"
                              >
                                <p style={{ margin: '0' }}>
                                  {trans.text_button.read_more_b}
                                </p>
                                <div>
                                  <img
                                    src="/assets/images/about/next-w.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>

            <div className="after-slide-mobile">
              <div className="after-slide-mobile-content">
                <div className="p-home__text-mobile">
                  <div
                    className="p-home__text"
                    data-aos="fade-up"
                    data-aos-delay="800"
                  >
                    <p>{trans.home.slider_text}</p>
                  </div>
                  <div
                    className="p-home__icon"
                    data-aos="fade-up"
                    data-aos-delay="800"
                  >
                    <div className="p-home__icon-items">
                      <div className="p-home__icon-item">
                        <div>
                          <img src="/assets/img/slider/ico_chiphi.svg" alt="" />
                        </div>
                        <div className="text-home">
                          <p>{trans.home.slider_text_icon_a}</p>
                        </div>
                      </div>
                      <div className="p-home__icon-item">
                        <div>
                          <img
                            src="/assets/img/slider/ico_chatluong.svg"
                            alt=""
                          />
                        </div>
                        <div className="text-home">
                          <p>{trans.home.slider_text_icon_b}</p>
                        </div>
                      </div>
                      <div className="p-home__icon-item">
                        <div>
                          <img
                            src="/assets/img/slider/ico_trienkhai.svg"
                            alt=""
                          />
                        </div>
                        <div className="text-home">
                          <p>{trans.home.slider_text_icon_c}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-home__container">
          <div className="p-home-content">
            <div className="p-home_content--img">
              <div
                className="p-home_txt"
                style={{ position: 'relative', height: '581px' }}
              >
                <div>
                  <div className="p-home_txt--img"></div>
                  <div className="p-home_txt--img-text">
                    <div className="p-home__text">
                      <p style={{ width: '1103px' }}>
                        {trans.home.slider_text}
                      </p>
                    </div>
                    <div className="p-home__icon">
                      <div className="p-home__icon-items">
                        <div className="p-home__icon-item">
                          <div>
                            <img
                              src="/assets/img/slider/ico_chiphi.svg"
                              alt=""
                            />
                          </div>
                          <div className="text-home">
                            <p>{trans.home.slider_text_icon_a}</p>
                          </div>
                        </div>
                        <div className="p-home__icon-item">
                          <div>
                            <img
                              src="/assets/img/slider/ico_chatluong.svg"
                              alt=""
                            />
                          </div>
                          <div className="text-home">
                            <p>{trans.home.slider_text_icon_b}</p>
                          </div>
                        </div>
                        <div className="p-home__icon-item">
                          <div>
                            <img
                              src="/assets/img/slider/ico_trienkhai.svg"
                              alt=""
                            />
                          </div>
                          <div className="text-home">
                            <p>{trans.home.slider_text_icon_c}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ backgroundColor: '#fff' }}>
                <div className="p-home__our-service u12uahdasbdabd">
                  <div className="p-home__our-service-title">
                    <h1>{trans.home.our_service_title}</h1>
                    <div className="oadisjdh22">
                      {/* <p>{trans.home.sub_our_service_title}</p> */}
                      <div className="p-home-title-service-abc">
                        <p>{trans.home.sub_our_service_title1}</p>
                        <p>{trans.home.sub_our_service_title2}</p>
                      </div>
                      <div className="p-home__our-service-read">
                        <div className="p-home__our-service-read-text"></div>
                        <Link href="/service">
                          <a className="p-home__our-service-read-icon">
                            <p> {trans.text_button.read_more}</p>
                            <img
                              src="/assets/img/slider/next-solid.svg"
                              alt=""
                            />
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="p-home__our-service-items">
                    {service &&
                      service?.map(data => {
                        return (
                          <Link
                            className="p-home__our-service-item"
                            href={
                              data?.step_action?.length > 0
                                ? `/service/${data?.seo_url}`
                                : ''
                            }
                          >
                            <a className="p-home__our-service-item iaihbaj1jsbdfbs">
                              <div className="p-home__our-service-item-icon">
                                <img src={data.image} alt="" />
                              </div>
                              <div className="p-home__our-service-item-text">
                                <p className="a2u32u3quajda">{data.title}</p>
                              </div>
                              <div className="p-home__our-service-item-des">
                                <p>{data.description}</p>
                              </div>
                              {data?.step_action?.length > 0 && (
                                <div className="p-home__our-service-item-more">
                                  <p> {trans.text_button.read_more}</p>
                                </div>
                              )}
                            </a>
                          </Link>
                        );
                      })}
                  </div>

                  <div className="p-home__our-service-title">
                    <h1>{trans.home.our_service_methods}</h1>
                    <div>
                      <div className="p-home-title-service-abc">
                        <p>{trans.home.sub_our_service_title1}</p>
                        <p>{trans.home.sub_our_service_title2}</p>
                      </div>
                      <div className="p-home__our-service-read">
                        <div className="p-home__our-service-read-text"></div>
                        <Link href="/offshore">
                          <a className="p-home__our-service-read-icon">
                            <p> {trans.text_button.read_more}</p>
                            <img
                              src="/assets/img/slider/next-solid.svg"
                              alt=""
                            />
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="p-home__our-service-methods">
                    <div className="p-home__our-service-methods-items">
                      {cooperate &&
                        cooperate?.map(data => {
                          return (
                            <div
                              className="p-home__our-service-methods-item"
                              key={data.id}
                            >
                              <div>
                                <div className="p-home__our-service-methods-item-icon">
                                  <img src={data.icon} alt="" />
                                </div>
                                <div className="p-home__our-service-methods-item-title">
                                  <p>{data.title}</p>
                                  <img
                                    src="/assets/img/home/line-three.png"
                                    alt=""
                                  />
                                </div>
                                <div className="p-home__our-service-methods-item-des">
                                  <p>{data.text}</p>
                                </div>
                                <Link href={data.url}>
                                  <a className="p-home__our-service-methods-item-control">
                                    <img src={data.next} alt="" />
                                  </a>
                                </Link>
                              </div>
                              <div className="img-service">
                                <img src={data.img} alt="" />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="r-process" style={{ margin: 0 }}>
              <div className="container">
                <div className="row">
                  <div className="col-md-12 col-lg-5">
                    <div className="col-left">
                      <div className="subtract-2">
                        <img
                          className="w-100"
                          // style={{ marginTop: '30px' }}
                          src="/assets/images/offshore/Subtract-2.png"
                          alt=""
                        />
                      </div>
                      <h3>{trans?.off_shore?.procedure}</h3>
                      <p>{trans?.off_shore?.procedure_des}</p>
                      <div className="subtract">
                        <img
                          src="/assets/img/slider/img4.png"
                          alt=""
                          className="w-100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" col-md-12 col-lg-7">
                    <div className="col-right">
                      <ul>
                        <li>
                          <div className="icon">
                            <svg
                              width={65}
                              height={65}
                              viewBox="0 0 65 65"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r="31.5"
                                fill="#0063AA"
                                stroke="white"
                              />
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r={28}
                                fill="white"
                              />
                              <g clipPath="url(#clip0_492_29506)">
                                <path
                                  d="M48.5323 29.5525C48.4931 29.8813 48.4618 30.21 48.4148 30.5388C47.8276 34.7267 45.6588 37.8343 41.971 39.8773C40.6399 40.621 39.1836 41.0202 37.6803 41.2237C37.3906 41.2629 37.1401 41.0828 37.1087 40.8167C37.0774 40.574 37.2497 40.3705 37.5394 40.2922C38.4633 40.0652 39.4263 39.9165 40.3111 39.5799C42.7461 38.6719 44.6253 37.0593 45.9641 34.8363C47.1229 32.9106 47.6554 30.8128 47.5692 28.574C47.4518 25.4429 46.2069 22.7971 43.9363 20.6445C43.9049 20.621 43.8736 20.5975 43.7953 20.5505C43.7953 21.0828 43.7875 21.5838 43.8031 22.077C43.8031 22.1709 43.9049 22.2726 43.9832 22.3588C45.1107 23.6817 45.8702 25.2002 46.2147 26.9067C46.6923 29.2629 46.4183 31.5329 45.3064 33.6699C44.0459 36.0965 42.1198 37.8343 39.5046 38.6875C36.1927 39.7678 33.0608 39.3059 30.2186 37.2863C28.0654 35.7521 26.6874 33.6543 26.1941 31.0711C25.466 27.2981 26.5308 24.0417 29.3652 21.4194C31.2521 19.6738 33.5306 18.8206 36.0987 18.7658C37.0383 18.7501 37.97 18.8754 38.8783 19.1259C38.9879 19.1572 39.0975 19.1807 39.2463 19.2198C39.2463 18.8441 39.2619 18.4997 39.2384 18.1631C39.2306 18.0926 39.1053 17.9987 39.0114 17.9752C37.4454 17.5681 35.8638 17.482 34.2744 17.7795C30.6414 18.4605 27.9167 20.4331 26.1472 23.6738C24.9179 25.9361 24.5186 28.3783 25.004 30.9067C25.9044 35.5799 28.7075 38.5858 33.2409 39.9713C33.8203 40.1513 34.4466 40.1983 35.0495 40.3C35.1748 40.3235 35.3001 40.3314 35.4175 40.3548C35.7072 40.4175 35.8717 40.6288 35.8325 40.8793C35.7934 41.1298 35.5663 41.2942 35.2766 41.2707C34.1726 41.1689 33.0921 40.9576 32.0508 40.5818C30.5553 40.0417 29.2086 39.2511 28.0185 38.1944C27.9558 38.1396 27.8932 38.0926 27.8149 38.03C27.5174 38.3509 27.2355 38.664 26.9223 39.0085C27.0632 39.1337 27.2433 39.2903 27.4077 39.4625C27.948 40.0182 27.948 40.7071 27.4077 41.2707C26.8988 41.7952 26.3821 42.304 25.8653 42.8206C24.1428 44.5427 22.4202 46.2648 20.6977 47.9869C19.7816 48.9028 18.8029 48.9028 17.8868 47.9869C17.5815 47.6738 17.2526 47.3764 16.9708 47.0476C16.3679 46.3353 16.3757 45.3881 16.9864 44.6758C17.0647 44.5818 17.1587 44.4879 17.2448 44.4018C19.4136 42.2257 21.5903 40.0574 23.7669 37.8813C24.4873 37.1611 25.1293 37.1611 25.8418 37.8734C25.9671 37.9987 26.061 38.1474 26.1941 38.3274C26.5386 37.9361 26.8127 37.6308 27.0946 37.3098C26.7422 36.8402 26.3272 36.3392 25.9671 35.7991C24.8474 34.1396 24.1819 32.3079 23.9783 30.3118C23.6651 27.3999 24.2915 24.6836 25.9201 22.2335C27.8854 19.2824 30.6414 17.4742 34.1491 16.8558C34.5484 16.7854 34.9478 16.7306 35.3471 16.6758C35.9108 16.6758 36.4745 16.6758 37.0383 16.6758C37.7978 16.8089 38.5572 16.9419 39.3167 17.0672C39.3715 17.075 39.4342 17.0515 39.4811 17.028C39.6456 16.9184 39.81 16.7932 39.9744 16.6758C41.0158 16.6758 42.0571 16.6758 43.0985 16.6758C43.6465 16.9263 43.858 17.3568 43.811 17.9517C43.7875 18.2727 43.8188 18.5936 43.8031 18.9145C43.7875 19.1807 43.8736 19.3451 44.0772 19.5173C46.2538 21.3255 47.6554 23.619 48.2504 26.3901C48.3835 26.9928 48.4462 27.619 48.5401 28.2296C48.5323 28.6758 48.5323 29.1141 48.5323 29.5525ZM40.2015 17.6308C40.2015 24.2139 40.2015 30.7815 40.2015 37.3803C40.3033 37.3333 40.3816 37.3098 40.4442 37.2785C41.2585 36.8636 41.9867 36.3314 42.6522 35.713C42.8009 35.5721 42.8636 35.4312 42.8636 35.2276C42.8557 33.5995 42.8557 31.9791 42.8636 30.3509C42.8636 30.2257 42.8714 30.1004 42.8949 29.983C42.9419 29.7325 43.1063 29.6073 43.3647 29.6151C43.6152 29.6308 43.764 29.7717 43.7953 30.0222C43.811 30.1239 43.8031 30.2335 43.8031 30.3353C43.8031 31.5408 43.8031 32.7541 43.8031 33.9595C43.8031 34.0613 43.811 34.1552 43.8188 34.2883C46.0894 31.3451 46.0268 26.5779 43.8031 23.7286C43.8031 23.8695 43.8031 23.9635 43.8031 24.0652C43.8031 25.255 43.8031 26.437 43.8031 27.6269C43.8031 27.7286 43.8031 27.8382 43.7875 27.94C43.7562 28.1826 43.6074 28.3157 43.3725 28.3314C43.1298 28.347 42.9497 28.2296 42.8949 27.9791C42.8714 27.846 42.8636 27.713 42.8636 27.5799C42.8636 24.394 42.8636 21.2081 42.8636 18.0222C42.8636 17.8969 42.8636 17.7795 42.8636 17.6386C41.9632 17.6308 41.1019 17.6308 40.2015 17.6308ZM39.0975 20.2374C35.6759 18.985 30.8763 19.9478 28.2925 24.1513C27.3686 25.6543 26.9145 27.2981 26.8988 29.0672C26.8753 30.9224 27.6896 33.1689 28.3943 33.9126C28.3943 33.7873 28.3943 33.6699 28.3943 33.5603C28.3943 31.8539 28.3943 30.1474 28.3943 28.4409C28.3943 27.713 28.7623 27.3529 29.4904 27.3451C30.2108 27.3372 30.9311 27.3451 31.6436 27.3451C31.7532 27.3451 31.8628 27.3451 31.996 27.3451C32.0038 27.2042 32.0116 27.1024 32.0116 27.0006C32.0116 26.3353 32.0116 25.6699 32.0116 25.0045C32.0116 24.1278 32.3405 23.7912 33.2096 23.7912C34.0004 23.7912 34.7912 23.7912 35.6054 23.7912C35.6133 23.6582 35.6211 23.5408 35.6211 23.4312C35.6211 22.758 35.6211 22.077 35.6211 21.4038C35.6211 20.5975 35.9734 20.2374 36.7799 20.2374C37.555 20.2374 38.3302 20.2374 39.0975 20.2374ZM36.592 21.1846C36.592 26.9067 36.592 32.5897 36.592 38.3666C37.3906 38.2022 38.1501 38.0456 38.9174 37.8969C39.1836 37.85 39.2541 37.7169 39.2541 37.4507C39.2463 32.1435 39.2463 26.8284 39.2463 21.5212C39.2463 21.4116 39.2384 21.302 39.2306 21.1768C38.338 21.1846 37.4767 21.1846 36.592 21.1846ZM32.9512 24.7462C32.9512 24.9184 32.9512 25.0515 32.9512 25.1846C32.9512 29.2002 32.9512 33.2237 32.9512 37.2394C32.9512 37.8265 32.8572 37.6856 33.4053 37.8656C34.1178 38.1004 34.846 38.2413 35.5976 38.2648C35.5976 33.7404 35.5976 29.2394 35.5976 24.7384C34.7129 24.7462 33.8516 24.7462 32.9512 24.7462ZM29.3339 28.3C29.3339 28.4566 29.3339 28.5818 29.3339 28.7071C29.3339 30.4449 29.3339 32.1826 29.3339 33.9204C29.3339 34.3666 29.2007 34.8832 29.3887 35.2433C29.6079 35.6738 30.0698 35.9869 30.4692 36.3C30.9389 36.668 31.4557 36.9732 31.996 37.3333C31.996 34.257 31.996 31.2903 31.996 28.2922C31.1112 28.3 30.2421 28.3 29.3339 28.3ZM21.3084 41.6777C20.1105 42.8754 18.9125 44.0574 17.7302 45.2629C17.3544 45.6386 17.3701 46.1317 17.7459 46.5231C18.0278 46.8284 18.3331 47.1181 18.6306 47.4077C19.0848 47.8539 19.5232 47.8539 19.9852 47.392C21.1048 46.2726 22.2245 45.1533 23.3441 44.0339C23.4068 43.9713 23.4616 43.9008 23.4929 43.8617C22.7569 43.1259 22.0444 42.4135 21.3084 41.6777ZM25.5756 41.8186C25.9671 41.4194 26.3586 41.0202 26.7501 40.621C26.9066 40.4566 26.9301 40.2922 26.7657 40.1278C26.1941 39.5564 25.6226 38.9772 25.0432 38.4057C24.8944 38.257 24.73 38.2492 24.5812 38.4057C24.1741 38.8128 23.7591 39.2276 23.3676 39.6269C24.0958 40.3548 24.8161 41.0672 25.5756 41.8186ZM22.0287 40.9811C22.7647 41.7169 23.4772 42.4292 24.1741 43.1259C24.3777 42.9145 24.5969 42.6953 24.7535 42.531C24.0566 41.8265 23.3363 41.1063 22.6238 40.3862C22.4437 40.5662 22.2401 40.7697 22.0287 40.9811Z"
                                  fill="#0063AA"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_492_29506">
                                  <rect
                                    width={32}
                                    height={32}
                                    fill="white"
                                    transform="translate(16.5312 16.6758)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="content">
                            <p>01</p>
                            <div className="text text-white">
                              <strong>{trans.home.procedure_step_1}</strong>{' '}
                              <br />
                              <span>{trans.home.procedure_step_sub_1}</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <svg
                              width={65}
                              height={65}
                              viewBox="0 0 65 65"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r="31.5"
                                fill="#0063AA"
                                stroke="white"
                              />
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r={28}
                                fill="white"
                              />
                              <g clipPath="url(#clip0_492_29514)">
                                <path
                                  d="M29.9562 52.7224C29.8098 52.6701 29.6633 52.6178 29.5169 52.5655C28.4812 52.1994 27.7803 51.237 27.7699 50.1177C27.7594 49.0506 27.7699 47.9836 27.7699 46.9166C27.749 46.8852 27.728 46.8643 27.7071 46.8538C26.2112 46.3203 25.6045 45.4625 25.594 43.8516C25.594 42.7008 25.6045 41.5606 25.2593 40.4413C24.9036 39.301 24.3596 38.2759 23.5437 37.3972C21.6816 35.3991 20.4786 33.0663 20.1962 30.3465C19.6731 25.2939 21.5142 21.235 25.7195 18.4001C30.6676 15.0735 37.2475 15.8267 41.4214 20.0738C41.5469 20.1994 41.662 20.3563 41.7143 20.5237C41.798 20.7852 41.6725 21.0153 41.4319 21.1513C41.1703 21.2978 40.9297 21.2246 40.7205 21.0258C40.2289 20.5864 39.7477 20.1157 39.2141 19.7182C32.4459 14.7178 22.7068 18.7139 21.4096 27.0199C20.8657 30.5243 21.7758 33.6626 24.1504 36.2988C25.8974 38.2445 26.8075 40.4727 26.7552 43.0879C26.7447 43.454 26.7447 43.8202 26.7656 44.1863C26.8075 45.0546 27.4142 45.7241 28.2302 45.7345C30.5211 45.7554 32.8225 45.745 35.1553 45.745C35.1553 43.2239 35.1553 40.7133 35.1553 38.1713C33.4188 38.1713 31.6823 38.1713 29.8935 38.1713C29.8935 38.3177 29.8935 38.4537 29.8935 38.6002C29.8935 40.2948 29.8935 41.9895 29.8935 43.6842C29.8935 44.1131 29.7052 44.3432 29.3599 44.3746C29.0043 44.406 28.7323 44.1549 28.7218 43.7365C28.7114 43.2553 28.7218 42.7741 28.7218 42.2929C28.7218 40.0961 28.7218 37.9097 28.7218 35.7129C28.7218 35.2213 28.816 34.7819 29.2344 34.4681C29.2972 34.4158 29.3599 34.3216 29.3599 34.2484C29.3076 33.286 29.3076 32.3236 29.1507 31.3717C29.0252 30.6185 28.5545 29.9908 28.0209 29.4364C27.592 28.9866 27.5502 28.6727 27.8326 28.1392C28.8997 26.1307 30.155 24.2478 31.5986 22.4799C32.1739 21.779 32.9271 21.7894 33.5025 22.5008C34.9147 24.2478 36.1596 26.1098 37.237 28.0869C37.5509 28.6623 37.5404 28.9447 37.1115 29.4364C35.9085 30.8172 35.5947 32.4491 35.7411 34.217C35.7516 34.3112 35.8039 34.4158 35.8771 34.4681C36.2746 34.7819 36.3792 35.2004 36.3792 35.6816C36.3792 38.8617 36.3792 42.0523 36.3792 45.2324C36.3792 45.3893 36.3792 45.5358 36.3792 45.6822C37.4881 45.881 38.3354 45.1906 38.3459 44.1026C38.3563 42.8264 38.2936 41.5501 38.6493 40.2948C39.0363 38.9349 39.6535 37.7214 40.6159 36.6858C42.2583 34.9284 43.3358 32.9094 43.7019 30.5243C44.1099 27.8986 43.6391 25.4403 42.3315 23.1284C42.2897 23.0552 42.2478 22.9924 42.206 22.9297C41.9863 22.5322 42.0386 22.1974 42.3524 22.0091C42.6663 21.8208 42.9696 21.9464 43.2207 22.3439C46.0347 26.8735 45.4907 32.9826 41.8817 36.9996C40.867 38.1294 40.0092 39.3324 39.7372 40.8388C39.5698 41.7803 39.6012 42.7532 39.5175 43.7156C39.4757 44.2072 39.4652 44.7198 39.3083 45.1696C38.9945 46.0693 38.2936 46.5923 37.3312 46.8538C37.3312 47.8999 37.3416 48.9565 37.3312 50.0026C37.3207 50.9859 36.9232 51.7705 36.0759 52.2935C35.7934 52.4714 35.4587 52.5655 35.1553 52.691C33.3979 52.7224 31.6718 52.7224 29.9562 52.7224ZM33.2305 24.0595C33.1991 24.0699 33.1573 24.0908 33.1259 24.1013C33.1259 24.2478 33.1259 24.3838 33.1259 24.5302C33.1259 25.9006 33.1259 27.271 33.1259 28.6414C33.1259 28.7983 33.1573 28.997 33.084 29.1016C32.948 29.2795 32.7493 29.4782 32.5505 29.5201C32.2785 29.5828 32.0589 29.3841 31.9856 29.1016C31.9543 28.9656 31.9543 28.8192 31.9543 28.6727C31.9543 27.2605 31.9543 25.8587 31.9543 24.4465C31.9543 24.3105 31.9438 24.185 31.9333 23.9967C31.2952 24.6557 29.3076 27.658 28.9729 28.474C28.9415 28.5681 28.9729 28.725 29.0357 28.8087C29.747 29.6247 30.2073 30.5557 30.4374 31.6123C30.4583 31.7064 30.6048 31.8529 30.6989 31.8529C32.0066 31.8738 33.3037 31.8633 34.6323 31.8633C34.8938 30.7126 35.3854 29.6874 36.1177 28.7773C36.17 28.7146 36.1282 28.5263 36.0759 28.4426C35.5633 27.5848 35.0507 26.7165 34.5067 25.8692C34.0987 25.252 33.6594 24.6557 33.2305 24.0595ZM28.9624 48.4439C29.1612 48.4439 29.3076 48.4439 29.4646 48.4439C31.0337 48.4439 32.5924 48.4439 34.1615 48.4439C34.3184 48.4439 34.5172 48.4125 34.6218 48.4962C34.7892 48.6427 35.0088 48.8623 35.0088 49.0506C35.0088 49.2389 34.7682 49.4377 34.6009 49.5841C34.5067 49.6574 34.3289 49.626 34.1824 49.626C32.6028 49.626 31.0232 49.626 29.4436 49.626C29.2867 49.626 29.1403 49.626 28.9938 49.626C28.8055 50.7872 29.4227 51.5508 30.5316 51.5508C31.902 51.5508 33.2723 51.5613 34.6427 51.5508C35.511 51.5508 36.1177 50.9441 36.1386 50.0758C36.1491 49.7411 36.1386 49.3958 36.1386 49.0611C36.1386 48.3602 36.1386 47.6593 36.1386 46.9585C33.7326 46.9585 31.358 46.9585 28.9729 46.9585C28.9624 47.4397 28.9624 47.9104 28.9624 48.4439ZM35.1448 36.9369C35.1448 36.4034 35.1448 35.9117 35.1448 35.4305C33.3874 35.4305 31.6509 35.4305 29.9144 35.4305C29.9144 35.9431 29.9144 36.4243 29.9144 36.9369C31.6718 36.9369 33.3979 36.9369 35.1448 36.9369ZM30.5525 33.0559C30.5525 33.4638 30.5525 33.8404 30.5525 34.2066C31.8915 34.2066 33.1991 34.2066 34.5172 34.2066C34.5172 33.8091 34.5172 33.4429 34.5172 33.0559C33.1886 33.0559 31.8915 33.0559 30.5525 33.0559Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M21.5724 17.25C21.7607 17.3232 21.9071 17.3546 21.9908 17.4278C22.2837 17.6998 22.5662 17.9823 22.8277 18.2961C23.0369 18.5472 23.0055 18.8401 22.7754 19.0597C22.5557 19.2794 22.2628 19.3003 22.0327 19.1016C21.7084 18.8191 21.405 18.5158 21.1539 18.1706C21.0598 18.045 21.0702 17.7626 21.1435 17.5952C21.2062 17.4488 21.4259 17.3546 21.5724 17.25Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M44.0883 17.8326C44.0046 18.0105 43.9732 18.1465 43.8896 18.2406C43.628 18.5335 43.3665 18.8264 43.0841 19.0775C42.8435 19.2867 42.561 19.2867 42.31 19.0566C42.0693 18.8474 42.0484 18.5126 42.2786 18.2511C42.5296 17.9686 42.7702 17.6757 43.0736 17.4561C43.2305 17.341 43.5234 17.2991 43.7117 17.3724C43.8582 17.4351 43.9628 17.6757 44.0883 17.8326Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M33.0986 13.7548C33.0986 13.9535 33.1091 14.1523 33.0986 14.3406C33.0672 14.6753 32.858 14.8636 32.5337 14.8741C32.2304 14.8846 31.9898 14.7067 31.9688 14.3929C31.9375 13.964 31.9375 13.5351 31.9688 13.1062C31.9898 12.7924 32.2304 12.625 32.5442 12.625C32.879 12.6355 33.0777 12.8238 33.1091 13.1585C33.1091 13.3677 33.0986 13.5665 33.0986 13.7548Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M22.4546 39.0078C22.5801 39.102 22.7998 39.2066 22.8625 39.3635C22.9253 39.5413 22.9148 39.8238 22.8102 39.9702C22.5801 40.2945 22.2767 40.5665 21.9838 40.8385C21.7641 41.0372 21.4608 41.0582 21.2829 40.8385C21.1469 40.6816 21.0214 40.3154 21.1051 40.2004C21.4085 39.7924 21.7955 39.4472 22.1617 39.081C22.2035 39.0497 22.3081 39.0497 22.4546 39.0078Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M42.6666 38.9766C42.8549 39.0707 43.0013 39.1126 43.0955 39.2067C43.357 39.4578 43.6185 39.7088 43.8591 39.9808C44.0997 40.2633 44.0893 40.5875 43.8382 40.8177C43.6081 41.0269 43.2838 41.0374 43.0327 40.7968C42.7712 40.5457 42.4888 40.3051 42.2795 40.0122C42.1645 39.8448 42.1331 39.5624 42.1958 39.3741C42.2586 39.2067 42.4992 39.1126 42.6666 38.9766Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M17.6315 29.708C17.4327 29.708 17.2444 29.7185 17.0457 29.708C16.7319 29.6767 16.554 29.4884 16.5331 29.1745C16.5122 28.8607 16.6691 28.6096 16.9725 28.5783C17.4118 28.5364 17.8512 28.5364 18.2905 28.5783C18.5939 28.6096 18.7613 28.8607 18.7404 29.1641C18.7194 29.4674 18.5311 29.6662 18.2173 29.6976C18.029 29.729 17.8303 29.708 17.6315 29.708Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M47.4088 29.7068C47.21 29.7068 47.0217 29.7277 46.823 29.7068C46.5091 29.6754 46.3313 29.4662 46.3208 29.1628C46.3104 28.8699 46.4568 28.6293 46.7497 28.5979C47.1996 28.5561 47.6598 28.5456 48.0992 28.5979C48.4026 28.6293 48.549 28.8908 48.5281 29.2046C48.4967 29.5185 48.3084 29.6963 47.9946 29.7172C47.7958 29.7172 47.6075 29.7068 47.4088 29.7068Z"
                                  fill="#0063AA"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_492_29514">
                                  <rect
                                    width={32}
                                    height="40.0863"
                                    fill="white"
                                    transform="translate(16.5312 12.6367)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="content">
                            <p>02</p>
                            <div className="text text-white">
                              <strong>{trans.home.procedure_step_2}</strong>{' '}
                              <br />
                              <span>{trans.home.procedure_step_sub_2}</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <svg
                              width={65}
                              height={65}
                              viewBox="0 0 126 126"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="62.5312"
                                cy="63.1797"
                                r="61.5901"
                                fill="#0063AA"
                                stroke="white"
                                strokeWidth="1.81981"
                              />
                              <circle
                                cx="62.5312"
                                cy="63.1797"
                                r="54.6875"
                                fill="white"
                              />
                              <g clipPath="url(#clip0_492_29562)">
                                <path
                                  d="M31.2734 44.5005C31.6485 43.7504 31.9094 42.9025 32.4148 42.2503C33.328 41.0763 34.6487 40.6523 36.1489 40.6523C45.2964 40.6686 54.4439 40.6523 63.6078 40.6523C69.5757 40.6523 75.5273 40.6523 81.4952 40.6523C82.4409 40.6523 82.8812 40.9295 82.8975 41.5492C82.9138 42.1688 82.4409 42.4786 81.4626 42.4786C66.3634 42.4786 51.2806 42.4786 36.1815 42.4786C34.2085 42.4949 33.0997 43.5874 33.0997 45.5441C33.0997 46.3594 33.0997 47.1747 33.0997 47.9899C33.0997 48.4465 33.0997 48.9194 33.0997 49.4248C52.7318 49.4248 72.2987 49.4248 91.9146 49.4248C91.9146 47.8921 91.9961 46.3757 91.8983 44.8918C91.8168 43.5222 90.6427 42.5601 89.2404 42.5112C88.311 42.4786 87.3653 42.5112 86.4359 42.4949C86.2402 42.4949 86.0282 42.4949 85.8325 42.446C85.3434 42.3481 85.0825 42.0383 85.0988 41.5492C85.1151 41.06 85.3923 40.7013 85.8815 40.7013C87.2838 40.685 88.7024 40.5871 90.0883 40.7828C92.1918 41.06 93.7571 43.0004 93.7734 45.169C93.8061 47.142 93.7734 49.115 93.7734 51.088C93.7734 58.8659 93.7734 66.6274 93.7734 74.4053C93.7734 74.6336 93.7898 74.8618 93.7408 75.0738C93.6267 75.5467 93.3169 75.8076 92.8114 75.7913C92.3385 75.775 92.0613 75.4978 91.9635 75.0575C91.9146 74.8455 91.9309 74.6173 91.9309 74.389C91.9309 66.9698 91.9309 59.5344 91.9309 52.1153C91.9309 51.8707 91.9309 51.6261 91.9309 51.3489C72.3151 51.3489 52.7481 51.3489 33.0997 51.3489C33.0997 52.6371 33.0997 53.9089 33.0997 55.1971C33.0997 55.8982 32.6431 56.3711 32.0561 56.2243C31.7626 56.1102 31.5343 55.8004 31.2734 55.6047C31.2734 51.9033 31.2734 48.2019 31.2734 44.5005Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M31.2734 58.8987C31.5996 58.5236 31.9583 58.1812 32.5127 58.4095C33.0671 58.6378 33.0997 59.1106 33.0997 59.6324C33.0997 66.6765 33.0997 73.7043 33.0997 80.7484C33.0997 82.7866 34.1759 83.8791 36.2141 83.8791C53.7428 83.8791 71.2715 83.8791 88.8002 83.8791C90.8547 83.8791 91.9146 82.7866 91.9146 80.7484C91.9146 80.1125 91.8983 79.4928 91.9146 78.8569C91.9309 78.2373 92.2896 77.846 92.8114 77.8297C93.3332 77.8133 93.7408 78.221 93.7408 78.8243C93.7245 79.9005 93.7898 80.993 93.6267 82.0528C93.3006 84.0585 91.6048 85.5097 89.5829 85.6727C89.3057 85.689 89.0122 85.7053 88.735 85.7053C71.2715 85.7053 53.7917 85.7053 36.3282 85.7053C34.7629 85.7053 33.3606 85.314 32.3822 84.0422C31.8931 83.4062 31.6322 82.5746 31.2734 81.8409C31.2734 74.1935 31.2734 66.5461 31.2734 58.8987Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M79.7694 68.8113C77.2257 68.8113 74.682 68.8439 72.1383 68.795C70.2795 68.7624 69.0566 66.985 69.611 65.2566C69.9697 64.1315 70.9643 63.3488 72.2362 63.3325C77.2747 63.3162 82.3131 63.3162 87.3679 63.3325C88.9496 63.3325 90.1236 64.5718 90.1236 66.0882C90.1236 67.6047 88.9496 68.7787 87.3516 68.8113C84.8079 68.8439 82.2805 68.8276 79.7694 68.8113ZM79.7694 67.0013C82.1012 67.0013 84.4492 67.0013 86.7809 67.0013C87.0092 67.0013 87.2212 67.0013 87.4495 66.985C87.9386 66.9361 88.2321 66.6263 88.2647 66.1534C88.2974 65.6317 88.0039 65.3055 87.4984 65.2077C87.319 65.1751 87.1397 65.1751 86.9603 65.1751C82.1827 65.1751 77.4051 65.1751 72.6275 65.1751C72.4319 65.1751 72.2199 65.1751 72.0242 65.224C71.5513 65.3381 71.2904 65.6806 71.3231 66.1534C71.3557 66.61 71.6166 66.9035 72.0894 66.9687C72.3014 67.0013 72.5297 67.0013 72.758 67.0013C75.0897 67.0013 77.4214 67.0013 79.7694 67.0013Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M77.5016 76.1336C75.6753 76.1336 73.8491 76.1825 72.0228 76.1173C70.2129 76.0521 69.0226 74.1769 69.6422 72.4811C70.0335 71.4049 71.0119 70.6875 72.2185 70.6712C75.7732 70.6549 79.3278 70.6386 82.8825 70.6712C84.4641 70.6875 85.6055 71.9104 85.5892 73.4432C85.5729 74.9433 84.4315 76.101 82.8662 76.1336C81.0888 76.1662 79.2952 76.1499 77.5016 76.1336ZM77.5342 74.3237C79.2626 74.3237 80.991 74.3237 82.7031 74.3237C83.388 74.3237 83.763 73.9812 83.763 73.4105C83.763 72.8561 83.388 72.4974 82.7031 72.4974C79.2789 72.4811 75.8384 72.4974 72.4142 72.4974C72.2348 72.4974 71.9902 72.4811 71.8924 72.5953C71.6641 72.8398 71.338 73.1823 71.3706 73.4432C71.4032 73.7367 71.7456 74.0465 72.0065 74.2747C72.1533 74.3889 72.4305 74.3237 72.6588 74.3237C74.273 74.3237 75.9036 74.3237 77.5342 74.3237Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M75.1184 61.491C74.1889 61.491 73.2432 61.5073 72.3138 61.491C70.6669 61.4584 69.4929 60.3006 69.4766 58.7679C69.4766 57.2026 70.6832 56.0285 72.3464 56.0122C74.1563 55.9959 75.9663 55.9959 77.7762 56.0122C79.4557 56.0285 80.6786 57.1699 80.6949 58.719C80.7112 60.317 79.5046 61.4584 77.7925 61.491C76.8957 61.5073 75.9989 61.5073 75.1184 61.491C75.1184 61.5073 75.1184 61.5073 75.1184 61.491ZM75.0531 59.6647C75.9663 59.6647 76.8794 59.681 77.7925 59.6647C78.461 59.6484 78.8687 59.306 78.8687 58.7516C78.8687 58.2135 78.461 57.8385 77.7925 57.8385C75.9826 57.8222 74.1726 57.8222 72.379 57.8385C71.7105 57.8385 71.3191 58.1972 71.3028 58.7516C71.3028 59.2897 71.6941 59.6484 72.3627 59.6647C73.2758 59.681 74.1726 59.6647 75.0531 59.6647Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M54.8157 58.1303C54.7668 58.2934 54.7016 58.4891 54.6363 58.6847C52.5329 64.2287 50.4457 69.7563 48.3423 75.3003C48.0651 76.0177 47.5922 76.2786 47.0541 76.0667C46.5324 75.8547 46.3693 75.3492 46.6302 74.6807C48.7499 69.1041 50.8697 63.5275 52.9731 57.951C53.1688 57.4292 53.4786 57.1031 54.0656 57.2009C54.5385 57.2824 54.7505 57.6248 54.8157 58.1303Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M39.6589 66.6782C41.159 68.1784 42.5939 69.6133 44.0452 71.0645C44.2082 71.2275 44.3713 71.3743 44.5017 71.5537C44.7952 71.945 44.7789 72.3689 44.4528 72.7114C44.0941 73.0864 43.6701 73.119 43.2462 72.8255C43.132 72.744 43.0342 72.6461 42.9364 72.532C41.2732 70.8688 39.61 69.2056 37.9305 67.5261C37.2946 66.8902 37.2783 66.45 37.9142 65.814C39.6263 64.1019 41.3384 62.3898 43.0505 60.6777C43.5886 60.1559 44.0615 60.0907 44.4854 60.482C44.9257 60.8897 44.8767 61.4278 44.3387 61.9659C42.8059 63.5475 41.2569 65.0803 39.6589 66.6782Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M61.598 66.6583C60.0489 65.1093 58.5488 63.6254 57.0486 62.1416C56.9182 62.0112 56.7714 61.897 56.6736 61.734C56.3964 61.31 56.3964 60.8861 56.7714 60.5273C57.1302 60.1849 57.5378 60.1849 57.9292 60.4621C58.0596 60.5599 58.1737 60.6741 58.2879 60.7882C59.9348 62.4351 61.598 64.082 63.2448 65.7452C63.9786 66.4789 63.9786 66.8703 63.2285 67.6203C61.5816 69.2672 59.9348 70.9304 58.2553 72.561C58.027 72.7893 57.6193 72.9849 57.3095 72.9523C57.0486 72.9197 56.6736 72.5936 56.6084 72.3327C56.5432 72.0392 56.6899 71.5989 56.9019 71.3707C58.2716 69.9521 59.6739 68.5661 61.0599 67.1801C61.2555 67.0496 61.4023 66.8866 61.598 66.6583Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M47.885 46.0332C47.8687 47.5496 46.6131 48.7889 45.113 48.7562C43.6292 48.7399 42.4062 47.4844 42.4062 46.0169C42.4062 44.5167 43.6455 43.2612 45.1619 43.2775C46.6784 43.2775 47.885 44.5004 47.885 46.0332ZM45.1619 45.1037C44.6564 45.1037 44.2162 45.5277 44.2325 46.0169C44.2488 46.4897 44.6728 46.9137 45.1293 46.9137C45.6348 46.93 46.0587 46.4897 46.0424 45.9843C46.0424 45.4951 45.6511 45.1037 45.1619 45.1037Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M54.9796 46.0174C54.9796 47.5338 53.724 48.7731 52.2076 48.7568C50.7238 48.7405 49.5008 47.5012 49.4845 46.0174C49.4682 44.5173 50.7238 43.2617 52.2402 43.2617C53.7729 43.278 54.9796 44.4847 54.9796 46.0174ZM53.137 46.0011C53.137 45.4956 52.762 45.1206 52.2565 45.1043C51.751 45.088 51.3108 45.5119 51.3108 46.0174C51.3108 46.4903 51.7347 46.9142 52.1913 46.9305C52.7131 46.9305 53.137 46.5066 53.137 46.0011Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M40.7997 46.0006C40.7997 47.517 39.5442 48.7562 38.0441 48.7562C36.5439 48.7562 35.3047 47.4844 35.3047 45.9843C35.321 44.5004 36.5439 43.2775 38.0278 43.2775C39.5605 43.2612 40.7997 44.4841 40.7997 46.0006ZM38.9572 46.0332C38.9735 45.544 38.5821 45.1364 38.093 45.1038C37.5712 45.0711 37.1472 45.4788 37.1309 45.9843C37.1146 46.4897 37.5549 46.93 38.0441 46.9137C38.5332 46.9137 38.9572 46.506 38.9572 46.0332Z"
                                  fill="#0063AA"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_492_29562">
                                  <rect
                                    width="62.5"
                                    height="45.0528"
                                    fill="white"
                                    transform="translate(31.2734 40.6523)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="content">
                            <p>03</p>
                            <div className="text text-white">
                              <div className="text text-white">
                                <strong>{trans.home.procedure_step_3}</strong>{' '}
                                <br />
                                <span>{trans.home.procedure_step_sub_3}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <svg
                              width={65}
                              height={65}
                              viewBox="0 0 65 65"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r="31.5"
                                fill="#0063AA"
                                stroke="white"
                              />
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r={28}
                                fill="white"
                              />
                              <g clipPath="url(#clip0_492_29529)">
                                <path
                                  d="M16.5312 46.1121C16.6731 45.5195 17.0404 45.0938 17.466 44.6765C19.1437 43.0239 20.7962 41.3547 22.4655 39.6937C22.9329 39.2263 23.2417 39.2263 23.7091 39.6937C23.851 39.8356 23.9679 39.9942 24.0764 40.1194C24.886 39.3098 25.6455 38.5503 26.4217 37.7741C23.8343 34.7443 22.741 31.2389 23.3753 27.2743C23.8928 24.0026 25.5203 21.3401 28.1411 19.2952C33.2323 15.3307 40.6523 15.9316 45.0842 20.6557C49.5829 25.4548 49.6914 32.7829 45.3012 37.7574C40.8609 42.7902 32.8234 43.5832 27.4483 38.8007C26.6804 39.5602 25.9209 40.3197 25.1113 41.1293C25.2115 41.2211 25.3617 41.3463 25.4953 41.4799C25.9877 41.964 25.9877 42.2644 25.5036 42.7485C24.043 44.2091 22.5907 45.6614 21.1301 47.122C20.8881 47.3641 20.6377 47.5978 20.404 47.8565C20.0701 48.2154 19.7029 48.5325 19.2104 48.6744C19.0018 48.6744 18.7931 48.6744 18.5845 48.6744C17.5579 48.3907 16.8317 47.7897 16.5312 46.7381C16.5312 46.5294 16.5312 46.3208 16.5312 46.1121ZM35.8865 18.0099C29.6434 18.0099 24.5438 23.0761 24.5354 29.2858C24.5271 35.5706 29.5683 40.6619 35.8281 40.6786C42.0962 40.6953 47.2042 35.604 47.2042 29.3275C47.1958 23.1178 42.0962 18.0182 35.8865 18.0099ZM23.0498 41.0041C23.0414 41.0125 23.008 41.0292 22.983 41.0625C21.3304 42.7151 19.6778 44.3594 18.0419 46.0203C17.9334 46.1288 17.8834 46.3708 17.9251 46.5127C17.9919 46.7297 18.1421 46.9384 18.3174 47.097C18.693 47.4392 18.9851 47.4058 19.3356 47.0469C20.8964 45.4778 22.4572 43.917 24.0179 42.3562C24.0931 42.2811 24.1598 42.206 24.2099 42.1559C23.8176 41.772 23.4337 41.3881 23.0498 41.0041Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M35.8345 35.9961C31.895 35.971 28.8653 32.6325 29.2242 28.7097C29.508 25.6048 31.9785 23.0842 35.1084 22.7337C35.3421 22.7086 35.5841 22.6836 35.8262 22.6836C36.2268 22.6836 36.5189 22.959 36.5273 23.3263C36.5356 23.6935 36.2685 23.9856 35.8596 24.0023C34.5659 24.0441 33.389 24.4196 32.4209 25.2877C30.7432 26.7817 30.134 28.6596 30.7516 30.813C31.3859 32.9914 32.905 34.3017 35.1585 34.6106C38.2132 35.0362 40.8924 32.8495 41.1679 29.778C41.1846 29.6194 41.1846 29.4692 41.2012 29.3106C41.2346 28.9267 41.5184 28.6679 41.8773 28.6763C42.2362 28.6846 42.5116 28.9684 42.52 29.3523C42.5283 30.187 42.3697 30.9882 42.0693 31.7561C41.0677 34.3351 38.5805 36.0211 35.8345 35.9961Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M36.4467 29.721C37.3397 28.611 38.166 27.5677 39.0007 26.5327C39.7685 25.5729 40.5364 24.6131 41.3043 23.6532C41.5713 23.3194 41.9636 23.261 42.2641 23.4863C42.5812 23.7284 42.6146 24.1123 42.3476 24.4795C42.3142 24.5213 42.2808 24.563 42.2557 24.6047C41.2208 25.8984 40.1858 27.1921 39.1509 28.4774C38.4832 29.3037 37.8238 30.1384 37.1561 30.9647C36.7638 31.4487 36.3882 31.4654 35.9542 31.0314C35.1446 30.2218 34.3267 29.4122 33.5254 28.5943C33.4002 28.4691 33.2834 28.3022 33.2333 28.1269C33.1498 27.8431 33.3084 27.551 33.5672 27.4258C33.8676 27.2756 34.1347 27.334 34.3684 27.5677C34.986 28.177 35.5953 28.7863 36.2046 29.4039C36.2797 29.4873 36.3382 29.5875 36.4467 29.721Z"
                                  fill="#0063AA"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_492_29529">
                                  <rect
                                    width={32}
                                    height="31.9917"
                                    fill="white"
                                    transform="translate(16.5312 16.6836)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="content">
                            <p>04</p>
                            <div className="text text-white">
                              <div className="text text-white">
                                <strong>{trans.home.procedure_step_4}</strong>{' '}
                                <br />
                                <span>{trans.home.procedure_step_sub_4}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <svg
                              width={65}
                              height={65}
                              viewBox="0 0 65 65"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r="31.5"
                                fill="#0063AA"
                                stroke="white"
                              />
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r={28}
                                fill="white"
                              />
                              <g clipPath="url(#clip0_492_29540)">
                                <path
                                  d="M16.5312 31.6781C16.573 31.3607 16.6148 31.0433 16.6482 30.7259C16.6983 30.2748 16.9656 30.0159 17.3415 30.0577C17.7174 30.0911 17.9429 30.4001 17.8928 30.8512C17.7424 32.0707 17.7424 33.2819 17.8928 34.5014C18.2603 37.3915 19.3796 39.9475 21.2506 42.1694C23.2637 44.5583 25.7779 46.1955 28.81 46.9472C33.7215 48.1668 38.1736 47.1561 42.0661 43.9235C44.7056 41.735 46.3344 38.895 47.011 35.5288C48.406 28.621 44.5636 21.5711 38.0149 18.9817C32.4101 16.7765 26.2039 18.0796 21.9941 22.3646C21.9022 22.4565 21.8103 22.5567 21.6683 22.7155C22.0943 22.7155 22.4284 22.7155 22.7709 22.7155C23.0799 22.7155 23.3973 22.7071 23.7064 22.7322C24.0322 22.7572 24.2577 23.0245 24.2577 23.3419C24.2577 23.6426 24.0489 23.8932 23.7315 23.9517C23.6396 23.9684 23.5477 23.9684 23.4475 23.9684C22.4702 23.9684 21.4845 23.9684 20.5072 23.9684C19.9058 23.9684 19.697 23.7596 19.697 23.1582C19.697 22.114 19.6887 21.0699 19.7054 20.0342C19.7054 19.675 19.9476 19.4328 20.2817 19.4161C20.6325 19.3993 20.8915 19.6165 20.9416 19.9841C20.9583 20.0843 20.9499 20.1929 20.9499 20.2931C20.9499 20.7108 20.9499 21.1284 20.9499 21.6129C21.0585 21.521 21.1254 21.4709 21.1838 21.4124C23.8818 18.7228 27.1227 17.1357 30.9066 16.7598C39.4767 15.8995 46.5767 21.7549 48.1721 29.2558C49.851 37.166 45.5576 44.976 38.0651 47.7074C36.6868 48.2085 35.2668 48.5259 33.8051 48.6345C33.7132 48.6429 33.6213 48.6679 33.5294 48.6847C32.8612 48.6847 32.193 48.6847 31.5247 48.6847C31.4579 48.6679 31.3827 48.6429 31.3159 48.6345C30.5892 48.5259 29.8458 48.4591 29.1274 48.3088C22.9379 47.0725 17.7842 41.735 16.7818 35.5038C16.6816 34.9024 16.6148 34.2926 16.5312 33.6828C16.5312 33.0146 16.5312 32.3464 16.5312 31.6781Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M26.863 24.251C27.1386 24.393 27.456 24.4933 27.6899 24.6937C28.1994 25.1364 28.7507 25.2701 29.3688 25.0195C29.9703 24.7689 30.271 24.2928 30.3044 23.6329C30.3461 22.831 30.864 22.3716 31.6742 22.3633C32.2506 22.3633 32.8186 22.3633 33.3949 22.3633C34.2135 22.3633 34.7147 22.8394 34.7732 23.658C34.84 24.6353 35.6085 25.2784 36.5523 25.103C36.8196 25.0529 37.1036 24.8942 37.3208 24.7188C37.9723 24.1842 38.6322 24.1842 39.2336 24.7856C39.6513 25.1949 40.0606 25.6042 40.4699 26.0219C41.0044 26.5731 41.0295 27.2748 40.5116 27.8428C40.0606 28.3356 39.9436 28.8869 40.1859 29.4883C40.4281 30.0897 40.8959 30.4071 41.5641 30.4405C42.366 30.4823 42.8421 31.0002 42.8504 31.7937C42.8504 32.3701 42.8504 32.9381 42.8504 33.5144C42.8504 34.3581 42.3827 34.8509 41.539 34.9094C40.5784 34.9762 39.9269 35.7613 40.1107 36.7052C40.1608 36.9725 40.3279 37.2482 40.5033 37.4653C41.0128 38.0835 41.0212 38.7684 40.4532 39.3364C40.0355 39.7624 39.6179 40.18 39.1919 40.5977C38.6322 41.149 37.9306 41.1657 37.3542 40.6394C36.8614 40.1967 36.3101 40.0798 35.7087 40.3304C35.1156 40.5726 34.8066 41.032 34.7732 41.6836C34.7314 42.5105 34.2219 42.9783 33.4033 42.9866C32.8269 42.9866 32.2589 42.9866 31.6826 42.9866C30.864 42.9866 30.3628 42.5105 30.3044 41.6919C30.2375 40.7146 29.4691 40.0715 28.5252 40.2469C28.2579 40.297 27.9739 40.4557 27.7567 40.6311C27.1219 41.1573 26.4453 41.1573 25.8606 40.581C25.4346 40.1633 25.017 39.7457 24.5993 39.3197C24.0647 38.7684 24.0397 38.0668 24.5576 37.4988C25.0086 37.0143 25.1256 36.4546 24.8833 35.8532C24.6411 35.2518 24.1733 34.9344 23.5051 34.901C22.7032 34.8592 22.2271 34.3414 22.2188 33.5478C22.2188 32.9715 22.2188 32.4035 22.2188 31.8271C22.2188 30.9835 22.6865 30.4907 23.5302 30.4322C24.4824 30.3654 25.1256 29.6053 24.9669 28.6614C24.9167 28.3774 24.758 28.0934 24.5743 27.8678C24.0647 27.2414 24.0564 26.5648 24.6244 25.9968C25.0504 25.5624 25.4764 25.1364 25.9107 24.7188C26.1947 24.4432 26.4871 24.3179 26.8296 24.3179C26.8296 24.3095 26.8463 24.2761 26.863 24.251ZM23.48 33.6481C24.6912 33.7149 25.5683 34.2578 26.0277 35.3688C26.4954 36.4881 26.2449 37.5071 25.4764 38.3591C25.9441 38.8269 26.3869 39.2779 26.8463 39.7373C27.715 38.9605 28.7257 38.7266 29.8366 39.1777C30.9642 39.6371 31.4988 40.5309 31.5657 41.7253C32.2255 41.7253 32.8604 41.7253 33.5035 41.7253C33.5704 40.5225 34.1133 39.6455 35.2242 39.1777C36.3435 38.7099 37.3626 38.9689 38.2229 39.729C38.6907 39.2612 39.1417 38.8185 39.5928 38.3591C38.816 37.4904 38.5737 36.4881 39.0332 35.3688C39.4926 34.2411 40.3863 33.7065 41.5808 33.6314C41.5808 32.9715 41.5808 32.345 41.5808 31.6935C40.378 31.6267 39.5009 31.0837 39.0415 29.9728C38.5737 28.8535 38.8243 27.8344 39.5928 26.9741C39.125 26.5063 38.6823 26.0636 38.2229 25.6042C37.3542 26.381 36.3519 26.6233 35.2409 26.1639C34.1216 25.7044 33.5704 24.8107 33.5035 23.6162C32.8437 23.6162 32.2172 23.6162 31.5657 23.6162C31.4988 24.819 30.9559 25.6961 29.845 26.1555C28.7257 26.6233 27.7066 26.3727 26.8463 25.6042C26.3785 26.072 25.9274 26.5147 25.468 26.9741C26.2449 27.8428 26.4871 28.8535 26.0277 29.9644C25.5683 31.0837 24.6745 31.6267 23.4717 31.6935C23.48 32.3701 23.48 32.9882 23.48 33.6481Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M37.2236 32.6821C37.2236 35.2631 35.1103 37.3764 32.5292 37.3681C29.9482 37.3681 27.8432 35.2464 27.8516 32.6654C27.8599 30.101 29.9649 27.9961 32.5292 27.9961C35.1103 27.9961 37.2236 30.101 37.2236 32.6821ZM35.9706 32.6737C35.9623 30.786 34.4003 29.2407 32.5125 29.249C30.6331 29.2574 29.0962 30.8027 29.0962 32.6821C29.0962 34.5698 30.6498 36.1235 32.5376 36.1235C34.4337 36.1151 35.979 34.5615 35.9706 32.6737Z"
                                  fill="#0063AA"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_492_29540">
                                  <rect
                                    width={32}
                                    height="32.0084"
                                    fill="white"
                                    transform="translate(16.5312 16.6758)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="content">
                            <p>05</p>
                            <div className="text text-white">
                              <strong>{trans.home.procedure_step_5}</strong>{' '}
                              <br />
                              <span>{trans.home.procedure_step_sub_5}</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <svg
                              width={65}
                              height={65}
                              viewBox="0 0 65 65"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r="31.5"
                                fill="#0063AA"
                                stroke="white"
                              />
                              <circle
                                cx="32.5312"
                                cy="32.6797"
                                r={28}
                                fill="white"
                              />
                              <g clipPath="url(#clip0_492_29550)">
                                <path
                                  d="M16.5312 29.8061C16.6564 29.2115 16.8207 28.6325 17.2198 28.1552C17.3919 27.9518 17.5797 27.7562 17.7831 27.5684C18.276 27.1068 18.5264 26.5435 18.4794 25.8706C18.4168 24.9161 18.6437 24.0555 19.2853 23.32C19.6765 22.8662 20.1537 22.5533 20.7249 22.3655C21.4838 22.1151 21.9533 21.6066 22.2271 20.8633C22.7904 19.3533 23.9484 18.5709 25.5757 18.6335C26.3738 18.6648 26.9997 18.3988 27.5396 17.8198C28.6427 16.6384 29.9806 16.3724 31.4515 17.0374C32.187 17.3738 32.8755 17.3738 33.611 17.0374C35.0662 16.3724 36.4119 16.6384 37.4995 17.8041C38.0628 18.4066 38.6965 18.6726 39.518 18.6413C41.0985 18.5865 42.2721 19.3689 42.8198 20.8477C43.1014 21.6144 43.5943 22.1073 44.3689 22.389C45.8476 22.9367 46.63 24.1103 46.5674 25.6907C46.5361 26.5122 46.8022 27.1538 47.4046 27.7093C48.5625 28.789 48.8364 30.1425 48.1792 31.5743C47.8349 32.3332 47.8349 33.0296 48.1792 33.7885C48.8364 35.2125 48.5547 36.5817 47.4046 37.6535C46.8022 38.209 46.5361 38.8506 46.5674 39.6721C46.6222 41.2526 45.8398 42.4183 44.3611 42.9738C43.5943 43.2633 43.1014 43.7484 42.8198 44.523C42.2799 46.0095 41.0437 46.8076 39.4555 46.7293C38.6809 46.6902 38.055 46.9328 37.5464 47.5274C37.03 48.1376 36.3728 48.5054 35.5748 48.6306C35.5357 48.6384 35.4965 48.6618 35.4652 48.6775C35.1914 48.6775 34.9254 48.6775 34.6515 48.6775C34.1665 48.5054 33.6814 48.3254 33.1963 48.1611C32.7503 48.0046 32.2965 48.0046 31.8584 48.1611C31.3733 48.3254 30.8882 48.5054 30.4031 48.6853C30.1528 48.6853 29.9024 48.6853 29.652 48.6853C28.8227 48.5288 28.0872 48.2081 27.5317 47.5508C27.0154 46.9406 26.366 46.7059 25.5679 46.7293C23.9484 46.7841 22.7904 46.0095 22.2271 44.4995C21.9454 43.7562 21.476 43.2477 20.7249 42.9973C20.1616 42.8095 19.6765 42.4966 19.2853 42.0428C18.6515 41.3073 18.4246 40.4467 18.4794 39.4922C18.5185 38.8193 18.276 38.256 17.7831 37.7944C17.5875 37.6144 17.3997 37.4188 17.2198 37.2076C16.8207 36.7303 16.6564 36.1513 16.5313 35.5645C16.5313 35.3142 16.5313 35.0638 16.5313 34.8134C16.7034 34.3284 16.8833 33.8433 17.0555 33.3582C17.2119 32.9122 17.2119 32.4584 17.0555 32.0203C16.8912 31.5352 16.7112 31.0501 16.5313 30.565C16.5312 30.3068 16.5312 30.0565 16.5312 29.8061ZM45.3234 25.8706C45.3782 24.564 44.9479 23.9303 43.7352 23.4765C42.7493 23.1088 42.0843 22.4281 41.7166 21.4423C41.2941 20.2843 40.629 19.8306 39.4007 19.8853C38.321 19.9323 37.4369 19.5567 36.7014 18.7665C35.8721 17.8589 35.1053 17.7181 33.9865 18.2345C33.0085 18.6883 32.0462 18.6883 31.0682 18.2345C29.9572 17.7181 29.1826 17.8667 28.3533 18.7665C27.6256 19.5567 26.7337 19.9323 25.654 19.8853C24.4256 19.8306 23.7606 20.2843 23.3381 21.4501C22.9704 22.4516 22.2897 23.1244 21.2882 23.4922C20.1224 23.9147 19.6765 24.5797 19.7313 25.8159C19.7782 26.8956 19.4026 27.7797 18.6124 28.5151C17.7048 29.3523 17.5562 30.1112 18.0804 31.2301C18.5342 32.2081 18.5342 33.1704 18.0804 34.1484C17.564 35.2594 17.7127 36.034 18.6124 36.8633C19.4026 37.5909 19.7782 38.4829 19.7313 39.5626C19.6765 40.7909 20.1303 41.4638 21.2882 41.8785C22.2897 42.2384 22.9704 42.9269 23.3303 43.9205C23.7528 45.0863 24.4178 45.5323 25.654 45.4775C26.7337 45.4306 27.6178 45.8061 28.3454 46.5963C29.1748 47.4961 29.9572 47.6447 31.0603 47.1284C32.0383 46.6746 33.0007 46.6746 33.9787 47.1284C35.074 47.6447 35.8643 47.4961 36.6701 46.612C37.4134 45.7983 38.3132 45.4149 39.4163 45.4697C40.6056 45.5244 41.2863 45.0628 41.6931 43.9362C42.0608 42.9112 42.7572 42.2227 43.7743 41.8472C44.0559 41.7455 44.3376 41.6125 44.5645 41.4325C45.1591 40.9631 45.3547 40.3137 45.3078 39.5704C45.2295 38.4672 45.6207 37.5596 46.4423 36.8242C46.5753 36.7068 46.7083 36.5817 46.81 36.4408C47.3498 35.7132 47.3655 34.9543 46.9665 34.1562C46.4814 33.1704 46.4892 32.1768 46.9665 31.1831C47.0525 31.0032 47.1308 30.8232 47.1777 30.6354C47.389 29.7592 47.076 29.0706 46.4188 28.4995C45.652 27.811 45.2843 26.9269 45.3234 25.8706Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M35.1077 29.3035C36.0153 29.3035 36.8838 29.2957 37.7601 29.3035C38.7615 29.3113 39.4892 29.992 39.5517 30.97C39.5517 30.9778 39.5596 30.9935 39.5517 31.0013C39.3561 31.5333 39.6613 31.815 40.0134 32.1671C40.7253 32.8869 40.5767 34.084 39.763 34.6942C39.6926 34.749 39.6143 34.8038 39.5283 34.8585C39.8334 35.8365 39.5517 36.5955 38.6755 37.1275C38.6755 37.1588 38.6676 37.1901 38.6755 37.2135C39.0275 38.4732 38.2451 39.5294 36.9307 39.5373C35.2016 39.5451 33.4725 39.5373 31.7434 39.5373C31.008 39.5373 30.296 39.3964 29.6153 39.1226C29.4667 39.06 29.3728 39.0991 29.2319 39.1774C28.9503 39.3338 28.6373 39.506 28.3244 39.5216C27.4324 39.5686 26.5327 39.5529 25.6407 39.5373C24.8349 39.5216 24.2403 38.9348 24.2324 38.129C24.2246 35.6644 24.2246 33.192 24.2324 30.7275C24.2324 29.906 24.8349 29.3113 25.6564 29.3035C26.5405 29.2879 27.4246 29.28 28.3087 29.3113C28.5747 29.3192 28.8564 29.4287 29.0989 29.5539C29.2554 29.64 29.3571 29.6556 29.5136 29.5695C30.1239 29.2409 30.7263 28.9123 31.094 28.2942C31.2583 28.0126 31.407 27.7074 31.5244 27.3945C31.806 26.6668 32.0564 25.9314 32.3224 25.1959C32.5337 24.6248 32.8153 24.4996 33.3865 24.7187C34.9356 25.3133 35.7728 27.0033 35.3268 28.615C35.2564 28.8419 35.186 29.061 35.1077 29.3035ZM33.316 26.1192C33.0892 26.7529 32.8623 27.3554 32.651 27.9578C32.3693 28.7558 31.939 29.4444 31.2583 29.9529C30.8359 30.2659 30.3508 30.5006 29.9048 30.7822C29.8187 30.837 29.7249 30.9622 29.717 31.0561C29.7092 33.2546 29.7092 35.4453 29.717 37.6439C29.717 37.7378 29.8187 37.8864 29.897 37.9021C30.476 38.0507 31.0627 38.262 31.6495 38.2776C33.3943 38.3245 35.1469 38.3011 36.8994 38.2933C37.2906 38.2933 37.5253 38.0898 37.5175 37.7847C37.5097 37.4874 37.2828 37.2996 36.9072 37.2996C36.5865 37.2918 36.2579 37.3074 35.9371 37.2918C35.5537 37.2761 35.2799 37.0179 35.272 36.6815C35.2642 36.3294 35.5459 36.0634 35.9449 36.0478C36.297 36.04 36.6491 36.0478 37.009 36.0478C37.2984 36.0478 37.5958 36.0556 37.8852 36.04C38.1826 36.0243 38.386 35.8131 38.3938 35.547C38.3938 35.281 38.1904 35.0776 37.8931 35.0463C37.807 35.0385 37.7288 35.0463 37.6427 35.0463C37.0872 35.0463 36.5395 35.0541 35.984 35.0463C35.5537 35.0385 35.272 34.7803 35.272 34.4204C35.2799 34.0605 35.5615 33.8101 35.9918 33.8023C36.2109 33.7945 36.43 33.8023 36.6491 33.8023C37.3219 33.8023 38.0026 33.8101 38.6755 33.7945C38.9884 33.7866 39.2075 33.5676 39.1997 33.2859C39.1918 33.0199 38.9884 32.8243 38.6833 32.8008C38.5972 32.793 38.519 32.8008 38.4329 32.8008C37.6192 32.8008 36.8055 32.8008 35.9997 32.8008C35.5694 32.8008 35.2799 32.5505 35.272 32.1906C35.2642 31.815 35.5537 31.5646 36.0075 31.5568C36.2579 31.549 36.5082 31.5568 36.7586 31.5568C37.1028 31.5568 37.4471 31.5646 37.7914 31.549C38.0965 31.5333 38.2921 31.3299 38.2921 31.0639C38.2921 30.7901 38.1043 30.5866 37.7992 30.5632C37.7131 30.5554 37.6349 30.5632 37.5488 30.5632C36.4691 30.5632 35.3816 30.5632 34.3019 30.5632C33.762 30.5632 33.4882 30.1876 33.6525 29.6634C33.7777 29.2566 33.9341 28.8576 34.0593 28.4507C34.3566 27.5118 34.1063 26.7138 33.316 26.1192ZM28.473 34.4439C28.473 33.2546 28.4652 32.0732 28.4808 30.884C28.4808 30.6414 28.4026 30.5475 28.1601 30.5554C27.3777 30.5632 26.5953 30.5632 25.8207 30.5554C25.5625 30.5554 25.4764 30.6492 25.4764 30.8996C25.4843 33.2546 25.4843 35.6096 25.4764 37.9568C25.4764 38.215 25.5547 38.3089 25.8207 38.3011C26.5874 38.2854 27.362 38.2854 28.1288 38.3011C28.4104 38.3089 28.4887 38.1994 28.4808 37.9334C28.4652 36.7754 28.473 35.6096 28.473 34.4439Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M19.9101 32.3949C20.0353 27.0042 23.5874 22.2472 28.7512 20.6433C32.0764 19.6184 35.3077 19.947 38.4138 21.5118C38.7972 21.7074 38.9302 22.0594 38.7581 22.388C38.6016 22.701 38.2417 22.8105 37.874 22.6306C36.7708 22.0751 35.6207 21.6761 34.4001 21.4726C28.3835 20.479 22.6642 24.391 21.4202 30.3607C20.9429 32.6531 21.1541 34.8907 22.0461 37.058C22.1008 37.191 22.1634 37.324 22.2104 37.4648C22.3199 37.8169 22.1791 38.1455 21.8661 38.2707C21.5375 38.4037 21.1933 38.2707 21.0524 37.903C20.8255 37.3318 20.5986 36.7607 20.4187 36.1817C20.0353 34.969 19.8788 33.6389 19.9101 32.3949Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M33.1441 45.2891C30.9612 45.3282 29.2243 44.9918 27.5656 44.2876C27.1431 44.1077 26.9788 43.7713 27.1197 43.427C27.2683 43.0827 27.6204 42.9576 28.0429 43.1375C29.5529 43.7713 31.1177 44.0999 32.7529 44.0529C35.8668 43.9747 38.5113 42.8011 40.6864 40.5791C42.3764 38.85 43.3778 36.7688 43.7456 34.3825C44.0977 32.1214 43.7769 29.9463 42.8223 27.8651C42.7285 27.6539 42.6111 27.4583 42.525 27.247C42.3607 26.8637 42.4624 26.5194 42.7832 26.3629C43.1118 26.2065 43.4404 26.3316 43.636 26.6994C44.348 28.0373 44.8096 29.4456 45.0131 30.9478C45.4434 34.226 44.7392 37.2461 42.8223 39.9453C40.8977 42.6602 38.2844 44.3659 35.014 45.0309C34.2864 45.1874 33.5275 45.2422 33.1441 45.2891Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M24.0636 40.547C24.4 40.5549 24.6973 40.8522 24.6973 41.1886C24.6973 41.5172 24.4156 41.7989 24.087 41.8067C23.7428 41.8067 23.422 41.4859 23.4298 41.1495C23.4377 40.8209 23.7271 40.5392 24.0636 40.547Z"
                                  fill="#0063AA"
                                />
                                <path
                                  d="M41.6504 24.2042C41.6583 24.5328 41.3844 24.8223 41.048 24.8301C40.7037 24.8379 40.4064 24.5563 40.3986 24.212C40.3908 23.8756 40.6646 23.5861 40.9932 23.5783C41.3218 23.5705 41.6426 23.8678 41.6504 24.2042Z"
                                  fill="#0063AA"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_492_29550">
                                  <rect
                                    width={32}
                                    height="31.9922"
                                    fill="white"
                                    transform="translate(16.5312 16.6836)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="content">
                            <p>06</p>
                            <div className="text text-white">
                              <div className="text text-white">
                                <strong>{trans.home.procedure_step_6}</strong>{' '}
                                <br />
                                <span>{trans.home.procedure_step_sub_6}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#fff' }}>
              <div className="p-home__our-service">
                <div className="p-home__our-service-title">
                  {/* <h1>{trans.home.our_service_title}</h1> */}
                  <h1>{trans.home.language_tech}</h1>
                  <div>
                    {/* <p>{trans.home.sub_our_service_title}</p> */}
                    <p>{trans.home.language_tech_sub}</p>
                    <div className="p-home__our-service-read">
                      <div className="p-home__our-service-read-text"></div>
                      {/* <div className='p-home__our-service-read-icon'>
                        <p>READ MORE</p>
                        <img src='/assets/img/slider/ico_read.png' alt='' />
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="p-home__back-end">
                  <div className="p-home__our-service-item language_technologys">
                    <div className="p-home__our-service-item-text">
                      <p>Backend</p>
                    </div>
                    <div className="lg-and-tech">
                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img src="/assets/img/slider/python.svg" alt="" />
                        </div>
                        <p>Python</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers ">
                        <div>
                          <img
                            src="/assets/img/slider/php.svg"
                            alt=""
                            style={{ width: '90px' }}
                          />
                        </div>
                        <p>PHP</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img
                            src="/assets/img/slider/net.svg"
                            alt=""
                            style={{ width: '68px' }}
                          />
                        </div>
                        <p>NetCore</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img
                            src="/assets/img/slider/java.svg"
                            alt=""
                            style={{ width: '90px' }}
                          />
                        </div>
                        <p>Java</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div
                          style={{ height: '70.76px' }}
                          className="oqjbfbab1bbfbaf"
                        >
                          <span></span>
                        </div>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img src="/assets/img/slider/lara.svg" alt="" />
                        </div>
                        <p>Laravel</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img src="/assets/img/slider/cs.svg" alt="" />
                        </div>
                        <p>C#</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img src="/assets/img/slider/nodejs.svg" alt="" />
                        </div>
                        <p>NodeJS</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img src="/assets/img/slider/go.svg" alt="" />
                        </div>
                        <p>Golang</p>
                      </div>

                      <div className="lg-and-tech-container lg-and-tech-containers">
                        <div>
                          <img src="/assets/img/slider/dj.svg" alt="" />
                        </div>
                        <p>Django</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-home__our-service-items our-language_technology">
                  {tech_language &&
                    tech_language?.map(data => {
                      return (
                        <div
                          className="p-home__our-service-item language_technology"
                          key={data.id}
                        >
                          {/* <div className="lg-img">
                            <img src={data.img} alt="" />
                          </div> */}
                          <div className="p-home__our-service-item-text">
                            <p>{data.title}</p>
                          </div>
                          <div className="lg-and-tech">
                            {data?.details &&
                              data?.details?.map(e => {
                                return (
                                  <div
                                    className="lg-and-tech-container"
                                    key={e.id}
                                  >
                                    <div>
                                      <img src={e.img} alt="" />
                                    </div>
                                    <p>{e.name}</p>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>

            <div className="r-featured-project r-featured-project-dt">
              <div className="container-img-project">
                <div className="title-left">
                  <h3>{trans.home.feature_project}</h3>
                  <div className="koquuruanv">
                    <p className="desc">
                      {trans.home.feature_project_description}
                    </p>
                    <div className="p-home__our-service-read">
                      <div className="p-home__our-service-read-text"></div>
                      <Link href="/project">
                        <a className="p-home__our-service-read-icon">
                          <p className="ihgbqjbfbafs">
                            {' '}
                            {trans.text_button.read_more}
                          </p>
                          <img
                            src="/assets/images/about/next-w.svg"
                            alt=""
                            className="mmakqrkqrkq"
                          />
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <div>{list_project.id}/{list_project.length}</div> */}

                <div className="i182ywehehqehq" id="i182ywehehqehq">
                  <div
                    className="next-f-qfhqw"
                    onClick={() => slider_feature?.current?.slickNext()}
                  >
                    <img src="/assets/img/tgo/icon-next_f.svg" alt="" />
                  </div>

                  <Slider
                    className="project"
                    ref={slider_feature}
                    {...setting_project_feature}
                  >
                    {project &&
                      project?.map((item, index) => {
                        return (
                          <div key={index} className="item">
                            <div className="inner">
                              <div className="">
                                <div className="image img-eyefire">
                                  <div
                                    className="img-project-img"
                                    style={{
                                      backgroundImage: `url(${item.background_image})`,
                                    }}
                                  >
                                    <Link href={`/project/${item.seo_url}`}>
                                      <a className="image">
                                        <div className="img-project-bg">
                                          <div>
                                            <h1>{item.name}</h1>
                                            <p>{item.description}</p>
                                          </div>
                                        </div>
                                      </a>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </Slider>
                </div>
                <div className="owl-nav">
                  <button
                    onClick={() => slider_feature?.current?.slickPrev()}
                    type="button"
                    role="presentation"
                    className="owl-prev disabled"
                  >
                    <svg
                      width={33}
                      height={33}
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_400_758)">
                        <path
                          d="M16.4414 0.14014C25.2778 0.140138 32.4414 7.30376 32.4414 16.1401C32.4414 24.9765 25.2778 32.1401 16.4414 32.1401C7.60504 32.1401 0.441412 24.9765 0.441411 16.1401C0.441409 7.30377 7.60503 0.140141 16.4414 0.14014ZM16.4414 29.4735C23.805 29.4734 29.7747 23.5038 29.7747 16.1401C29.7747 8.77651 23.805 2.80683 16.4414 2.80683C9.07778 2.80683 3.1081 8.77652 3.1081 16.1401C3.1081 23.5038 9.07779 29.4735 16.4414 29.4735Z"
                          fill="#0063AA"
                        />
                        <path
                          d="M18.1653 8.53065C18.686 8.00997 19.5302 8.00996 20.0509 8.53065C20.5716 9.05134 20.5716 9.89559 20.0509 10.4163L14.327 16.1402L20.0509 21.864C20.5716 22.3847 20.5716 23.229 20.0509 23.7497C19.5302 24.2703 18.686 24.2703 18.1653 23.7497L11.4986 17.083C10.9779 16.5623 10.9779 15.718 11.4986 15.1973L18.1653 8.53065Z"
                          fill="#0063AA"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_400_758">
                          <rect
                            width={32}
                            height={32}
                            fill="white"
                            transform="matrix(-1 1.74846e-07 1.74846e-07 1 32.4414 0.140137)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  <button
                    onClick={() => slider_feature?.current?.slickNext()}
                    type="button"
                    role="presentation"
                    className="owl-next"
                  >
                    <svg
                      width={33}
                      height={33}
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_400_751)">
                        <path
                          d="M16.4414 0.14014C7.60503 0.140138 0.441405 7.30376 0.441403 16.1401C0.441402 24.9765 7.60502 32.1401 16.4414 32.1401C25.2778 32.1401 32.4414 24.9765 32.4414 16.1401C32.4414 7.30377 25.2778 0.140141 16.4414 0.14014ZM16.4414 29.4735C9.07778 29.4734 3.10809 23.5038 3.10809 16.1401C3.10809 8.77651 9.07778 2.80683 16.4414 2.80683C23.805 2.80683 29.7747 8.77652 29.7747 16.1401C29.7747 23.5038 23.805 29.4735 16.4414 29.4735Z"
                          fill="#0063AA"
                        />
                        <path
                          d="M14.7175 8.53065C14.1969 8.00997 13.3526 8.00996 12.8319 8.53065C12.3112 9.05134 12.3112 9.89559 12.8319 10.4163L18.5558 16.1402L12.8319 21.864C12.3112 22.3847 12.3112 23.229 12.8319 23.7497C13.3526 24.2703 14.1969 24.2703 14.7175 23.7497L21.3842 17.083C21.9049 16.5623 21.9049 15.718 21.3842 15.1973L14.7175 8.53065Z"
                          fill="#0063AA"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_400_751">
                          <rect
                            width={32}
                            height={32}
                            fill="white"
                            transform="translate(0.441406 0.140137)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
                <Link href="/project">
                  <a className="read-more d-flex d-md-none">
                    {trans.text_button.read_more}
                    <svg
                      width={33}
                      height={32}
                      viewBox="0 0 33 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="16.4414" cy={16} r={16} fill="#0063AA" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.44141 16.2491C5.44141 16.0501 5.52042 15.8594 5.66108 15.7187C5.80173 15.5781 5.99249 15.4991 6.19141 15.4991L23.8809 15.4991L19.1604 10.7801C19.0196 10.6392 18.9405 10.4482 18.9405 10.2491C18.9405 10.0499 19.0196 9.85888 19.1604 9.71805C19.3012 9.57722 19.4922 9.49811 19.6914 9.49811C19.8906 9.49811 20.0816 9.57722 20.2224 9.71805L26.2224 15.7181C26.2923 15.7877 26.3477 15.8705 26.3855 15.9616C26.4233 16.0527 26.4427 16.1504 26.4427 16.2491C26.4427 16.3477 26.4233 16.4454 26.3855 16.5365C26.3477 16.6276 26.2923 16.7104 26.2224 16.7801L20.2224 22.7801C20.0816 22.9209 19.8906 23 19.6914 23C19.4922 23 19.3012 22.9209 19.1604 22.7801C19.0196 22.6392 18.9405 22.4482 18.9405 22.2491C18.9405 22.0499 19.0196 21.8589 19.1604 21.7181L23.8809 16.9991L6.19141 16.9991C5.99249 16.9991 5.80173 16.92 5.66108 16.7794C5.52042 16.6387 5.44141 16.448 5.44141 16.2491Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </Link>
              </div>
            </div>

            <div className="r-featured-project-mb">
              <div className="container-img-project container-img-project-mb">
                <div className="title-left">
                  <h3>{trans.home.feature_project}</h3>
                  <div className="koquuruanv">
                    <p className="desc">
                      {trans.home.feature_project_description}
                    </p>
                    <div className="p-home__our-service-read">
                      <div className="p-home__our-service-read-text"></div>
                      <Link href="/project">
                        <a className="p-home__our-service-read-icon">
                          <p className="ihgbqjbfbafs">
                            {' '}
                            {trans.text_button.read_more}
                          </p>
                          <img
                            src="/assets/images/about/next-w.svg"
                            alt=""
                            className="mmakqrkqrkq"
                          />
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="slide-feature-mb">
                <Slider {...setting_project_feature_mb}>
                  {project &&
                    project?.map((item, index) => {
                      return (
                        <div key={index} className="item">
                          <div className="inner">
                            <div className="">
                              <div className="image img-eyefire">
                                <Link href={`/project/${item.seo_url}`}>
                                  <a className="image">
                                    <div
                                      className="img-project-img"
                                      style={{
                                        backgroundImage: `url(${item.background_image})`,
                                      }}
                                    >
                                      <div className="img-project-bg">
                                        <div>
                                          <h1>{item.name}</h1>
                                          <p>{item.description}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Slider>
              </div>
            </div>

            <div className="p-home_content--img">
              <div className="p-home_txt p-home__achievement-comtenet">
                <div className="p-home__achievement">
                  <div className="p-home__achievement-title">
                    <h1>{trans.home.achievement_title}</h1>
                    <p>{trans.home.achievement_text}</p>
                  </div>
                  <div className="p-home__achievement-title-content">
                    <div className="p-home__achievement-title-items">
                      <div
                        className="p-home__achievement-title-item"
                        style={{ backgroundColor: '#0063AA' }}
                      >
                        <div className="p-home__achievement-title-item-icon">
                          <img src="assets/img/slider/project.svg" alt="" />
                        </div>
                        <div className="p-home__achievement-title-item-number">
                          500+
                        </div>
                        <div className="p-home__achievement-title-item-text">
                          {trans.about.achievement_project}
                        </div>
                      </div>

                      <div
                        className="p-home__achievement-title-item"
                        style={{ backgroundColor: '#FDE002' }}
                      >
                        <div className="p-home__achievement-title-item-icon">
                          <img src="assets/img/slider/customer.svg" alt="" />
                        </div>
                        <div
                          className="p-home__achievement-title-item-number"
                          style={{ color: '#0063AA' }}
                        >
                          200+
                        </div>
                        <div
                          className="p-home__achievement-title-item-text"
                          style={{ color: '#0063AA' }}
                        >
                          {trans.home.achievement_customer}
                        </div>
                      </div>

                      <div
                        className="p-home__achievement-title-item"
                        style={{ backgroundColor: '#EB2725' }}
                      >
                        <div className="p-home__achievement-title-item-icon">
                          <img src="assets/img/slider/engineer.svg" alt="" />
                        </div>
                        <div className="p-home__achievement-title-item-number">
                          100+
                        </div>
                        <div className="p-home__achievement-title-item-text">
                          {trans.home.achievement_engineer}
                        </div>
                      </div>

                      <div
                        className="p-home__achievement-title-item"
                        style={{ backgroundColor: '#00BE90' }}
                      >
                        <div className="p-home__achievement-title-item-icon">
                          <img src="assets/img/slider/expert.svg" alt="" />
                        </div>
                        <div className="p-home__achievement-title-item-number">
                          10+
                        </div>
                        <div className="p-home__achievement-title-item-text">
                          {trans.home.achievement_expert}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="r-customer">
              <div className="container">
                <div className="title-center">
                  <h3>{trans?.about?.customer}</h3>
                  <p>{trans.about.customer_text}</p>
                  <p>{trans.about.customer_text1}</p>
                </div>
              </div>
              <div className="container-fluid">
                <ul className="brands-list">
                  <li>
                    <img src="/assets/images/about/brand-7.png" alt="Fujtsu" />
                  </li>
                  <li>
                    <img src="/assets/images/about/union.svg" alt="Viettel" />
                  </li>
                  <li>
                    <img src="/assets/images/about/brand-2.png" alt="Viettel" />
                  </li>
                  <li>
                    <img src="/assets/images/about/robot.svg" alt="Viettel" />
                  </li>
                  <li>
                    <img src="/assets/images/about/ric.svg" alt="Fujtsu" />
                  </li>

                  <li>
                    <img src="/assets/images/about/mcp.svg" alt="Fujtsu" />
                  </li>

                  <li>
                    <img src="/assets/images/about/nguyenhoang.svg" alt="Nhg" />
                  </li>

                  <li>
                    <img src="/assets/images/about/tue.svg" alt="Novaon" />
                  </li>

                  <li>
                    <img
                      src="/assets/images/about/brand-1.png"
                      alt="Tri nam group"
                    />
                  </li>

                  <li>
                    <img src="/assets/images/about/intel.svg" alt="Viettel" />
                  </li>
                  <li>
                    <img src="/assets/images/about/brand-6.png" alt="Luvina" />
                  </li>

                  <li>
                    <img src="/assets/images/about/brand-4.png" alt="Fpt" />
                  </li>

                  <li>
                    <img src="/assets/images/about/bk.svg" alt="Nhg" />
                  </li>
                  <li>
                    <img src="/assets/images/about/vinh.svg" alt="Nhg" />
                  </li>
                  <li>
                    <img src="/assets/images/about/kinhky.svg" alt="Nhg" />
                  </li>

                  <li>
                    <img src="/assets/images/about/cdtd.svg" alt="Nhg" />
                  </li>
                  <li>
                    <img src="/assets/images/about/gd.svg" alt="Nhg" />
                  </li>
                  <li>
                    <img src="/assets/images/about/vmo.svg" alt="Doke" />
                  </li>
                  <li>
                    <img src="/assets/images/about/qua.svg" alt="Viettel" />
                  </li>
                </ul>
              </div>
            </div>
            <div
              className={isShowModal ? 'bg-video' : 'bg-video-non-active'}
            ></div>
            <div
              id="about"
              className="about-slide-home"
              style={{ paddingTop: '180px', backgroundColor: '#fff' }}
            >
              <div
                className={
                  isShowModal ? 'video-company' : 'video-company-non-active'
                }
                onClick={() => {
                  setIsShowModal(false);
                  refClickYoutube?.current?.player?.player?.player?.pauseVideo();
                }}
              >
                <div className="video-company-container">
                  <ReactPlayer
                    width="100%"
                    height="595px"
                    url="https://www.youtube.com/embed/elZzejeEeSo"
                    ref={refClickYoutube}
                    controls={true}
                  />
                </div>
              </div>
              <div className="r-office-tcom r-office-tcom-home">
                <div className="container-fluid container-fluids ">
                  <div className="row" style={{ display: 'flex' }}>
                    <div
                      className="col-12 col-xl-3 col-left responsive-about"
                      style={{ position: 'relative' }}
                    >
                      <div className="circle circle-1" />
                      <div className="circle circle-2" />
                      <div className="circle circle-3" />
                      <div className="inner">
                        <p>{trans.home.office_video}</p>
                        <h3 className="j2eqwuueeqwieqwueqweq">
                          {trans.home.office_title}
                        </h3>
                        <a
                          onClick={() => {
                            setIsShowModal(true);
                            refClickYoutube?.current?.player?.player?.player?.playVideo();
                          }}
                          className="btn-start"
                          style={{ textDecoration: 'none' }}
                        >
                          {trans.home.play_video}
                          <svg
                            width={40}
                            height={40}
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 2.5C10.3359 2.5 2.5 10.3359 2.5 20C2.5 29.6641 10.3359 37.5 20 37.5C29.6641 37.5 37.5 29.6641 37.5 20C37.5 10.3359 29.6641 2.5 20 2.5ZM25.6289 20.2695L17.0977 26.4766C17.0509 26.5102 16.9958 26.5302 16.9383 26.5346C16.8809 26.5389 16.8234 26.5273 16.7721 26.501C16.7208 26.4748 16.6778 26.4349 16.6477 26.3858C16.6176 26.3367 16.6017 26.2803 16.6016 26.2227V13.8164C16.6014 13.7587 16.6172 13.7021 16.6472 13.6528C16.6772 13.6035 16.7203 13.5635 16.7717 13.5372C16.8231 13.5109 16.8807 13.4994 16.9382 13.5038C16.9958 13.5083 17.051 13.5286 17.0977 13.5625L25.6289 19.7656C25.6692 19.7941 25.7021 19.8319 25.7248 19.8757C25.7475 19.9196 25.7593 19.9682 25.7593 20.0176C25.7593 20.0669 25.7475 20.1156 25.7248 20.1594C25.7021 20.2033 25.6692 20.241 25.6289 20.2695Z"
                              fill="#0063AA"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                    <div className="col-12 col-xl-9 col-right slider-home">
                      <div className="tcom-image tcom-image-home">
                        <Slider {...setting_office}>
                          {company &&
                            company?.map(data => {
                              return (
                                <div className="slide-home">
                                  <div
                                    className="item item-slide-office"
                                    key={data.id}
                                  >
                                    <img
                                      src={data.url}
                                      alt=""
                                      style={{ borderRadius: '25px' }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
